var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 6,
    viewBox: "0 0 28 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 3,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 3,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotIcon3);
export default __webpack_public_path__ + "static/media/dotIcon3.d3d5a279b87374828fffc2f05bb61519.svg";
export { ForwardRef as ReactComponent };